<template>
  <router-view/>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import CustomerBenefits from '@/mixins/CustomerBenefits';
import MoneyBackPromotions from '@/mixins/MoneyBackPromotion';
import AmbassadorsTouchPointPopup
  from '@/pages/responsive-pages/authenticated/navigation-pages/ambassadors/AmbassadorsTouchPointPopup';
import SubscriptionCtaPopup from '../../pages/responsive-pages/authenticated/trial/SubscriptionCtaPopup.vue';
import SubscriptionMbgCtaPopup from '../../pages/responsive-pages/authenticated/trial/SubscriptionMbgCtaPopup.vue';

export default {
  name: 'PoupupManager',
  mixins: [CustomerBenefits, MoneyBackPromotions],
  props: {
    hideCta: {
      type: Boolean,
      default: false,
    },
  },
  async created() {
    if (this.hasMoneyBackOffer && !this.hideCta) {
      if (this.showMbgPopup) {
        this.openModal({
          component: SubscriptionMbgCtaPopup,
        });
      }
    } else if (this.shouldShowCta && !this.hideCta) {
      this.openModal({
        component: SubscriptionCtaPopup,
      });
    } else if (await this.shouldShowTrialPromotion({ inTrial: this.inTrial, inTrialSince: this.since })) {
      this.openModal({
        component: AmbassadorsTouchPointPopup,
        props: {
          touchPointText: 'שמחים שבחרת לצמוח איתנו!',
          onCloseCallback: this.dismissTrialPromotion,
        },
      });
    }
  },
  computed: {
    ...mapGetters('subscriptionState', ['shouldShowCta', 'inTrial']),
    ...mapState('subscriptionState', ['since']),
  },
  methods: {
    ...mapActions('loader', ['startLoading', 'doneLoading']),
    ...mapActions('modalRootStore', ['openModal']),
    ...mapActions('ambassadorsTouchPoints', ['shouldShowTrialPromotion', 'dismissTrialPromotion']),
  },
};
</script>
